import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Format a price in cents to a USD string (e.g., 29900 → "$299.00") */
export function formatPrice(cents: number): string {
  if (!Number.isFinite(cents) || cents < 0) return '$0.00';
  return `$${(cents / 100).toFixed(2)}`;
}
